import Chip from '@mui/material/Chip';
import { EReviewSubmissionStatus, type TReviewSubmissionStatus } from '@onesource/schemas';
import { FC } from 'react';

/** One look per review status, shared by the chip and the status tiles. */
export const REVIEW_STATUS_STYLE: Record<TReviewSubmissionStatus, { label: string; bg: string; color: string }> = {
  [EReviewSubmissionStatus.waiting]: { label: 'Waiting', bg: '#fff4e5', color: '#b45309' },
  [EReviewSubmissionStatus.in_progress]: { label: 'Draft', bg: '#e8f1fd', color: '#1d5fb8' },
  [EReviewSubmissionStatus.reviewed]: { label: 'Reviewed', bg: '#e8f5e9', color: '#2e7d32' },
  [EReviewSubmissionStatus.rejected]: { label: 'Rejected', bg: '#fdecee', color: '#c62828' },
};

export const ReviewStatusChip: FC<{ status: TReviewSubmissionStatus }> = ({ status }) => {
  const style = REVIEW_STATUS_STYLE[status];
  return (
    <Chip
      size="small"
      label={style.label}
      sx={{ height: 22, fontSize: '0.72rem', fontWeight: 600, bgcolor: style.bg, color: style.color }}
    />
  );
};
